import React from "react";
import { Container } from "react-bootstrap";

import DepositIcon from "../../../../assets/images/icons/Deposit.webp";
import WithdrawIcon from "../../../../assets/images/icons/withdraw.webp";
import AccountStatementIcon from "../../../../assets/images/icons/AccountStatement.webp";
import MybetsIcon from "../../../../assets/images/icons/MyBet.webp";

import DepositImg from "../../../../assets/images/banner/deposit.gif";
import WithdrawImg from "../../../../assets/images/banner/withdraw.gif";
import AccountStatementImg from "../../../../assets/images/banner/accountstatement.gif";
import MybetsImg from "../../../../assets/images/banner/mybets.gif";

const Activity = () => {
  return (
    <div>
      <main>
        <div className="ActivitySection">
          <div className="ActivityHeading">
            <h1>Activity</h1>
            <p>Please remember to follow the event page</p>
            <p>We will launch user feedback activities from time to time</p>
          </div>
          <div className="ActivityBox mb-4">
            <ul>
              <li>
                <a href="/gatewaylist">
                  <img src={DepositIcon} alt="DepositIcon" />
                  <span>Deposit</span>
                </a>
              </li>
              <li>
                <a href="/withdraw">
                  <img src={WithdrawIcon} alt="WithdrawIcon" />
                  <span>Withdraw</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={MybetsIcon} alt="MybetsIcon" />
                  <span>Deposit History</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AccountStatementIcon} alt="AccountStatementIcon" />
                  <span>Account Statement</span>
                </a>
              </li>
            </ul>
          </div>
          {/* <div className="ActivityImg">
            <ul>
              <li>
                <img src={DepositImg} />
              </li>
              <li>
                <img src={MybetsImg} />
              </li>
              <li>
                <img src={WithdrawImg} />
              </li>
              <li>
                <img src={AccountStatementImg} />
              </li>
            </ul>
          </div> */}
        </div>
      </main>
    </div>
  );
};

export default Activity;
